import React from 'react';

import { ItemIcon, Icon } from '~ui';

export default function TagsItemIcon() {
  return (
    <ItemIcon className='flex items-center justify-center text-[var(--tag-color)]'>
      <Icon name='tag' size='micro' />
    </ItemIcon>
  );
}
